import { useLanguage } from "@/contexts/LanguageContext";
import { motion } from "framer-motion";
import { Target } from "lucide-react";
import SEOHead from "@/components/SEOHead";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function About() {
  const { t } = useLanguage();

  return (
    <div className="py-16 lg:py-24">
      <SEOHead
        title="Despre Noi"
        description="WITTMANN ROMANIA - Partenerul dumneavoastră pentru mașini de injecție, roboți industriali, termoregulatoare și uscătoare plastic. Experiență în prelucrarea maselor plastice."
        path="/despre-noi"
        keywords="WITTMANN Romania, masini de injectie, roboti industriali, mase plastice, injectie plastic, termoregulatoare"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "WITTMANN ROMANIA",
            url: "https://wittmann-group.ro",
          },
          {
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: "WITTMANN Romania – Prezentare",
            description: "Prezentare generală WITTMANN Romania – soluții complete pentru industria maselor plastice.",
            thumbnailUrl: "https://img.youtube.com/vi/rdosORFvbN0/hqdefault.jpg",
            uploadDate: "2026-02-18",
            contentUrl: "https://www.youtube.com/watch?v=rdosORFvbN0",
            embedUrl: "https://www.youtube.com/embed/rdosORFvbN0",
          },
          {
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: "WITTMANN Romania – Echipa și activitate",
            description: "Echipa WITTMANN Romania și activitatea în domeniul mașinilor de injecție și roboților industriali.",
            thumbnailUrl: "https://img.youtube.com/vi/_3FWQNKvRIY/hqdefault.jpg",
            uploadDate: "2026-02-20",
            contentUrl: "https://www.youtube.com/watch?v=_3FWQNKvRIY",
            embedUrl: "https://www.youtube.com/embed/_3FWQNKvRIY",
          },
        ]}
      />
      <div className="section-container">
        <motion.div {...fadeUp} className="max-w-3xl mx-auto">
          <h1 className="text-3xl lg:text-5xl font-bold text-foreground mb-3">{t("about.title")}</h1>
          <p className="text-lg text-primary font-medium mb-10">{t("about.subtitle")}</p>

          <div className="space-y-6 text-muted-foreground leading-relaxed">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p>{t("about.p3")}</p>
          </div>

          <motion.div {...fadeUp} className="mt-14">
            <h2 className="text-xl font-bold text-foreground mb-6">{t("about.teamTitle")}</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="aspect-video rounded-xl overflow-hidden">
                <iframe
                  src="https://www.youtube.com/embed/rdosORFvbN0"
                  title="WITTMANN Video 1"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
              <div className="aspect-video rounded-xl overflow-hidden">
                <iframe
                  src="https://www.youtube.com/embed/_3FWQNKvRIY"
                  title="WITTMANN Video 2"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
            </div>
          </motion.div>

          <motion.div
            {...fadeUp}
            className="mt-14 bg-primary/5 border border-primary/10 rounded-xl p-8"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Target className="w-5 h-5 text-primary" />
              </div>
              <h2 className="text-xl font-bold text-foreground">{t("about.missionTitle")}</h2>
            </div>
            <p className="text-muted-foreground leading-relaxed">{t("about.missionDesc")}</p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
